import { render, staticRenderFns } from "./shopSelector.vue?vue&type=template&id=5b20aa85&scoped=true&"
import script from "./shopSelector.vue?vue&type=script&lang=js&"
export * from "./shopSelector.vue?vue&type=script&lang=js&"
import style0 from "./shopSelector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./shopSelector.vue?vue&type=style&index=1&id=5b20aa85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b20aa85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b20aa85')) {
      api.createRecord('5b20aa85', component.options)
    } else {
      api.reload('5b20aa85', component.options)
    }
    module.hot.accept("./shopSelector.vue?vue&type=template&id=5b20aa85&scoped=true&", function () {
      api.rerender('5b20aa85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shopSelector.vue"
export default component.exports